import "./App.css";
import Routes from "./Components/Routes/Routes";

function App() {
  return (
    <div className="">
      <Routes></Routes>
    </div>
  );
}

export default App;
